import { SVGProps } from "react"
import { twMerge } from "tailwind-merge"

const IconMedia = ({ className, ...props }: SVGProps<SVGSVGElement> & { className?: string }) => {
  return (
    <svg viewBox="0 0 21 17" fill="none" xmlns="http://www.w3.org/2000/svg" className={twMerge("size-4", className)} {...props}>
      <rect x="1.75" y="0.75" width="17.5" height="15.5" rx="1.25" stroke="currentColor" strokeWidth="1.5" />
      <circle cx="7.77419" cy="4.77419" r="1.77419" stroke="currentColor" strokeWidth="1.5" />
      <path d="M1.5 13L5.36667 9.21739L8.56667 12.3478L14.0333 7L19.5 12.3478" stroke="currentColor" strokeWidth="1.5" />
    </svg>
  )
}

export default IconMedia
